export const DURATION_TOKEN_TYPE = {
  7: { value: 7 },
  30: { value: 30 },
  60: { value: 60 },
  90: { value: 90 },
  FOREVER: { value: 'FOREVER', label: 'foreverAppLabel' },
  CUSTOM: { value: 'CUSTOM', label: 'customAppLabel' },
};

export const MAX_APP_NAME_LENGTH = 25;

export const SERVICE_TYPE = {
  TTS: 'tts',
  STT: 'stt',
};

export const DEFAULT_SERVICE_TYPE = SERVICE_TYPE.TTS;

export const REQUEST_STATUS = {
  ALL: 'ALL',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const STT_REQUEST_STATUS_MAP = {
  COMPLETED: 'SUCCESS',
  FAILED: 'FAILURE',
  PENDING: 'IN_PROGRESS',
  PROCESSING: 'IN_PROGRESS',
};

export const STT_REQUEST_STATUS = {
  ALL: 'ALL',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const STT_REQUEST_STATUS_OPTIONS = {
  [STT_REQUEST_STATUS.ALL]: {
    label: 'allStatus',
    value: STT_REQUEST_STATUS.ALL,
  },
  [STT_REQUEST_STATUS.PROCESSING]: {
    label: 'sttProcessingRequest',
    value: STT_REQUEST_STATUS.PROCESSING,
  },
  [STT_REQUEST_STATUS.COMPLETED]: {
    label: 'successRequest',
    value: STT_REQUEST_STATUS.COMPLETED,
  },
  [STT_REQUEST_STATUS.FAILED]: {
    label: 'failureRequest',
    value: STT_REQUEST_STATUS.FAILED,
  },
};

export const REQUEST_STATUS_OPTIONS = {
  [REQUEST_STATUS.ALL]: {
    label: 'allStatus',
    value: REQUEST_STATUS.ALL,
  },
  [REQUEST_STATUS.IN_PROGRESS]: {
    label: 'inProgressRequest',
    value: REQUEST_STATUS.IN_PROGRESS,
  },
  [REQUEST_STATUS.SUCCESS]: {
    label: 'successRequest',
    value: REQUEST_STATUS.SUCCESS,
  },
  [REQUEST_STATUS.FAILURE]: {
    label: 'failureRequest',
    value: REQUEST_STATUS.FAILURE,
  },
};
